import { Subscription as StoresSubscription } from '@wix/ambassador-wix-ecommerce-subscriptions/types';
import { Subscription } from '@wix/ambassador-billing-v1-subscription/types';
import { LineItemOption, SubscriptionLineItemResource } from './slotTypes';

const toIsoDateString = (date: Date | string | null | undefined): string => {
  const parsed = date ? new Date(date) : undefined;
  return parsed && !isNaN(parsed.getTime()) ? parsed.toISOString() : '';
};

export const buildLineItemResources = (
  subscription: Subscription,
  storesSubscription: StoresSubscription | undefined,
): SubscriptionLineItemResource[] => {
  const subscriptionId = storesSubscription?.id;
  const currency = subscription.billingSettings?.currency;

  if (!subscriptionId || !currency) {
    return [];
  }

  const subscriptionName = subscription.name ?? '';
  const nextBillingDate = toIsoDateString(subscription.billingStatus?.nextBillingDate);
  const currentCycleNumber = subscription.billingStatus?.currentCycle ?? 0;
  const { frequency, interval, billingCycles } = storesSubscription?.subscriptionSettings ?? {};

  return (storesSubscription?.lineItems ?? []).flatMap((lineItem, position) => {
    const { productId, name: productName, mediaItem } = lineItem.productDetails ?? {};
    const options = lineItem.options?.filter(
      (optionSelection): optionSelection is LineItemOption => !!optionSelection.option && !!optionSelection.selection,
    );

    return productId && productName
      ? [
          {
            id: `${productId}:${lineItem.index ?? position}`,
            subscriptionId,
            productId,
            productName,
            subscriptionName,
            nextBillingDate,
            currency,
            currentCycleNumber,
            quantity: lineItem.quantity,
            pricePerUnit: lineItem.chargeDetails?.price,
            variantId: lineItem.variantId,
            options,
            imageUrl: mediaItem?.url,
            frequency,
            interval,
            billingCycles,
          },
        ]
      : [];
  });
};
